import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import CircularGauge from '../../../shared/components/CircularGauge/CircularGauge';
import { usePartitionsStatusData } from '../../hooks/usePartitionsStatusData';
import styles from './partitionStatus.module.scss';

export default memo(function PartitionsStatus(props) {
    const [t] = useTranslation(['common', 'dashboard']);

    usePartitionsStatusData(props.getPartitionsStatusRequest);

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.titleContainer}>
                    <span>{t('common:partition', { count: 2 })}</span>
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:partitions_status_detail')}
                    >
                        <span>{t('dashboard:partitions_status_detail')}</span>
                    </Tooltip>
                </div>
                {props.partitionsStatus.fetching && <CircularLoader size={24} />}
                {
                    !props.partitionsStatus.fetching &&
                    props.partitionsStatus.error &&
                    props.partitionsStatus.status &&
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:update_error')}
                    >
                        <div>
                            <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
                        </div>
                    </Tooltip>
                }
            </div>
            {
                props.partitionsStatus.error &&
                !props.partitionsStatus.status &&
                <div className={styles.cloudError}>
                    <SVG cacheGetRequests className={styles.icon} src="./icons/cloud_error.svg" />
                    <span>{t('common:no_information_available')}</span>
                </div>
            }
            {
                props.partitionsStatus.status &&
                <div className={styles.informationContainer}>
                    <div className={styles.progressBarContainer}>
                        <CircularGauge
                            exist={props.partitionsStatus.status.apps}
                            percentage={props.partitionsStatus.status.apps ? props.partitionsStatus.status.apps.usedPercentage : 0}
                        />
                        <span className={styles.detail}>{t('app', { count: 2 })}</span>
                        <span className={styles.capacityDetail}>
                            {
                                props.partitionsStatus.status.apps &&
                                <span>
                                    {props.partitionsStatus.status.apps.capacity}{props.partitionsStatus.status.apps.unit}
                                </span>
                            }
                        </span>
                    </div>
                    <div className={styles.progressBarContainer}>
                        <CircularGauge
                            exist={props.partitionsStatus.status.system}
                            percentage={props.partitionsStatus.status.system.usedPercentage}
                        />
                        <span className={styles.detail}>{t('system')}</span>
                        <span className={styles.capacityDetail}>
                            {props.partitionsStatus.status.system.capacity}{props.partitionsStatus.status.system.unit}
                        </span>
                    </div>
                    <div className={styles.progressBarContainer}>
                        <CircularGauge
                            exist={props.partitionsStatus.status.data}
                            percentage={props.partitionsStatus.status.data ? props.partitionsStatus.status.data.usedPercentage : 0}
                        />
                        <span className={styles.detail}>{t('data')}</span>
                    </div>
                </div>
            }
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.partitionsStatus === nextProps.partitionsStatus &&
        prevProps.getPartitionsStatusRequest === nextProps.getPartitionsStatusRequest
);
